if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }

      updateVariantAvailability(productData) {
        if (!productData || !productData.variants) return;
        
        const fieldsets = this.querySelectorAll('fieldset');
        
        fieldsets.forEach((fieldset, index) => {
          const inputs = fieldset.querySelectorAll('input[type="radio"]');
          const optionPosition = index + 1; // option1, option2, option3
          
          inputs.forEach(input => {
            const optionValue = input.value;
            
            // Find variants that match this option value
            const matchingVariants = productData.variants.filter(v => {
              return v[`option${optionPosition}`] === optionValue;
            });
            
            if (matchingVariants.length === 0) return;
            
            // Check if ALL matching variants have low stock or are unavailable
            const allLowStock = matchingVariants.every(v => 
              v.inventory_quantity <= 0 && v.inventory_policy === 'continue'
            );
            const allUnavailable = matchingVariants.every(v => !v.available);
            
            // Remove existing status classes
            input.classList.remove('low-stock', 'disabled');
            
            if (allLowStock) {
              input.classList.add('low-stock');
            } else if (allUnavailable) {
              input.classList.add('disabled');
            }
          });
        });
      }
    }
  );
}
